import React from 'react';

export const UserFlexSelect = ({
  usersShowDisable,
  setUsersShowDisable,
  name,
  shouldShowInitialText = true
}) => {
  return (
    <label
      className="form-control-label mb-0"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        whiteSpace: 'nowrap'
      }}
    >
      <input
          type="checkbox"
          id="usersShowDisable"
          checked={usersShowDisable}
          onChange={(e) => setUsersShowDisable(e.target.checked)}
          style={{ margin: 0, flexShrink: 0, position: 'static' }}
        />
      <span>{shouldShowInitialText && 'Mostrar desabilitados'} ({name})</span>
    </label>
  );
};
